import { getApplicationStateIdentifier } from '@resistdesign/voltra/app/utils';

const READ = getApplicationStateIdentifier();
const SAVE = getApplicationStateIdentifier();
const RESUME_UPLOAD_URL = getApplicationStateIdentifier();
const AUDIO_SAMPLE_UPLOAD_URL = getApplicationStateIdentifier();

export const PROFILE = getApplicationStateIdentifier({
  READ,
  SAVE,
  RESUME_UPLOAD_URL,
  AUDIO_SAMPLE_UPLOAD_URL,
});
